import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["id", "data-message-id", "data-seen", "data-next-message-id", "data-previous-message-id"]
const _hoisted_2 = { class: "message-body__scroll" }
const _hoisted_3 = {
  key: 1,
  class: "message-buttons-bar"
}
const _hoisted_4 = {
  key: 2,
  class: "message-unread-marker"
}
const _hoisted_5 = { class: "message-unread-marker__wrapper" }
const _hoisted_6 = { class: "message-unread-marker__text" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ReactionsWrapper = _resolveComponent("ReactionsWrapper")
  const _component_MessageBody = _resolveComponent("MessageBody")
  const _component_MessageButtonsBar = _resolveComponent("MessageButtonsBar")
  const _component_IconUnfoldMoreHorizontal = _resolveComponent("IconUnfoldMoreHorizontal")
  const _component_IconUnfoldLessHorizontal = _resolveComponent("IconUnfoldLessHorizontal")
  const _component_NcButton = _resolveComponent("NcButton")
  const _component_MessageForwarder = _resolveComponent("MessageForwarder")
  const _component_MessageTranslateDialog = _resolveComponent("MessageTranslateDialog")
  const _component_NcAssistantButton = _resolveComponent("NcAssistantButton")
  const _directive_intersection_observer = _resolveDirective("intersection-observer")

  return (_openBlock(), _createElementBlock("li", {
    id: `message_${$props.message.id}`,
    ref: "message",
    "data-message-id": $props.message.id,
    "data-seen": $data.seen,
    "data-next-message-id": $props.nextMessageId,
    "data-previous-message-id": $props.previousMessageId,
    class: _normalizeClass(["message", { 'message--hovered': $options.showMessageButtonsBar }]),
    tabindex: "0",
    onAnimationend: _cache[7] || (_cache[7] = (...args) => ($options.clearHighlightedClass && $options.clearHighlightedClass(...args))),
    onMouseover: _cache[8] || (_cache[8] = (...args) => ($options.handleMouseover && $options.handleMouseover(...args))),
    onMouseleave: _cache[9] || (_cache[9] = (...args) => ($options.handleMouseleave && $options.handleMouseleave(...args)))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([{
				'normal-message-body': !$options.isSystemMessage && !$options.isDeletedMessage,
				system: $options.isSystemMessage,
				'combined-system': $props.isCombinedSystemMessage,
			}, "message-body"])
    }, [
      _createVNode(_component_MessageBody, {
        "rich-parameters": $options.richParameters,
        "is-deleting": $data.isDeleting,
        "has-call": $options.conversation.hasCall,
        message: $props.message,
        "read-info": $options.readInfo
      }, {
        default: _withCtx(() => [
          (Object.keys($props.message.reactions).length)
            ? (_openBlock(), _createBlock(_component_ReactionsWrapper, {
                key: 0,
                id: $props.message.id,
                token: $props.message.token,
                "can-react": $options.canReact,
                "show-controls": $data.isHovered || $data.isFollowUpEmojiPickerOpen,
                onEmojiPickerToggled: $options.toggleFollowUpEmojiPicker
              }, null, 8, ["id", "token", "can-react", "show-controls", "onEmojiPickerToggled"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["rich-parameters", "is-deleting", "has-call", "message", "read-info"])
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      ($options.showMessageButtonsBar)
        ? (_openBlock(), _createBlock(_component_MessageButtonsBar, {
            key: 0,
            ref: "messageButtonsBar",
            "is-action-menu-open": $data.isActionMenuOpen,
            "onUpdate:isActionMenuOpen": _cache[0] || (_cache[0] = $event => (($data.isActionMenuOpen) = $event)),
            "is-emoji-picker-open": $data.isEmojiPickerOpen,
            "onUpdate:isEmojiPickerOpen": _cache[1] || (_cache[1] = $event => (($data.isEmojiPickerOpen) = $event)),
            "is-reactions-menu-open": $data.isReactionsMenuOpen,
            "onUpdate:isReactionsMenuOpen": _cache[2] || (_cache[2] = $event => (($data.isReactionsMenuOpen) = $event)),
            "is-forwarder-open": $data.isForwarderOpen,
            "onUpdate:isForwarderOpen": _cache[3] || (_cache[3] = $event => (($data.isForwarderOpen) = $event)),
            class: "message-buttons-bar",
            "is-translation-available": $setup.isTranslationAvailable,
            "can-react": $options.canReact,
            message: $props.message,
            "previous-message-id": $props.previousMessageId,
            "read-info": $options.readInfo,
            onShowTranslateDialog: _cache[4] || (_cache[4] = $event => ($data.isTranslateDialogOpen = true)),
            onReply: $options.handleReply,
            onEdit: $options.handleEdit,
            onDelete: $options.handleDelete
          }, null, 8, ["is-action-menu-open", "is-emoji-picker-open", "is-reactions-menu-open", "is-forwarder-open", "is-translation-available", "can-react", "message", "previous-message-id", "read-info", "onReply", "onEdit", "onDelete"]))
        : ($options.showCombinedSystemMessageToggle)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_NcButton, {
                variant: "tertiary",
                "aria-label": $options.t('spreed', 'Show or collapse system messages'),
                title: $options.t('spreed', 'Show or collapse system messages'),
                onClick: $options.toggleCombinedSystemMessage
              }, {
                icon: _withCtx(() => [
                  ($props.isCombinedSystemMessageCollapsed)
                    ? (_openBlock(), _createBlock(_component_IconUnfoldMoreHorizontal, { key: 0 }))
                    : (_openBlock(), _createBlock(_component_IconUnfoldLessHorizontal, { key: 1 }))
                ]),
                _: 1
              }, 8, ["aria-label", "title", "onClick"])
            ]))
          : _createCommentVNode("", true)
    ]),
    ($data.isForwarderOpen)
      ? (_openBlock(), _createBlock(_component_MessageForwarder, {
          key: 0,
          id: $props.message.id,
          token: $props.message.token,
          onClose: _cache[5] || (_cache[5] = $event => ($data.isForwarderOpen = false))
        }, null, 8, ["id", "token"]))
      : _createCommentVNode("", true),
    ($setup.isTranslationAvailable && $data.isTranslateDialogOpen)
      ? (_openBlock(), _createBlock(_component_MessageTranslateDialog, {
          key: 1,
          message: $props.message.message,
          "rich-parameters": $options.richParameters,
          onClose: _cache[6] || (_cache[6] = $event => ($data.isTranslateDialogOpen = false))
        }, null, 8, ["message", "rich-parameters"]))
      : _createCommentVNode("", true),
    ($options.isLastReadMessage)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString($options.t('spreed', 'Unread messages')), 1),
            ($options.shouldShowSummaryOption)
              ? (_openBlock(), _createBlock(_component_NcAssistantButton, {
                  key: 0,
                  disabled: $data.loading,
                  onClick: $options.generateSummary
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($options.t('spreed', 'Generate summary')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"]))
              : _createCommentVNode("", true)
          ])
        ])), [
          [_directive_intersection_observer, $options.lastReadMessageVisibilityChanged]
        ])
      : _createCommentVNode("", true)
  ], 42, _hoisted_1))
}